<template>
  <div>
    <v-card>
      <v-toolbar dense dark color="primary">
        <v-toolbar-title><h4 class="font-weight-light">OPCEO MONTHLY EVALUATION EMPLOYEES</h4>
        </v-toolbar-title>
      </v-toolbar>
      <v-layout row wrap class="align-center mx-2 mt-5 mb-5">
        <v-flex xs12 md12>
          <v-select
            v-model="month_of_id"
            class="mx-2"
            dense
            outlined
            label="Month Of"
            :items="month_of_items"
            item-value="id"
            item-text="month_of"
            @change="selected_data"
          ></v-select>
        </v-flex>
        <v-col cols="12" v-show="alert">
          <v-alert
            color="warning"
            text
            class="mb-0"
          >
            <div class="d-flex align-start">
              <v-icon color="warning">
                {{ icons.mdiAlertOutline }}
              </v-icon>

              <div class="ms-3">
                <p class="text-base font-weight-medium mb-1">
                  {{ alert_message }}
                </p>
              </div>
            </div>
          </v-alert>
        </v-col>
        <v-col cols="12" md="12">
          <v-btn
            class="w-full"
            color="info"
            @click="print_data"
            v-if="!is_printing"
          >
            Print Data
          </v-btn>
          <v-progress-circular
            :size=50
            :width="5"
            color="primary"
            indeterminate
            v-else
          ></v-progress-circular>
        </v-col>
      </v-layout>

      <v-toolbar dense dark color="primary">
        <v-toolbar-title><h4 class="font-weight-light">TOP 3 Managers</h4>
        </v-toolbar-title>
      </v-toolbar>
      <v-data-table dense
                    class="mt-3"
                    :headers="top_head_headers"
                    :items="top_head_data"
                    disable-pagination
                    hide-default-footer
      >
      </v-data-table>
      <v-toolbar dense dark color="primary">
        <v-toolbar-title><h4 class="font-weight-light">Top 1 Employee per Department</h4>
        </v-toolbar-title>
      </v-toolbar>
      <v-data-table dense
                    class="mt-3"
                    :headers="top_per_deparment_headers"
                    :items="top_per_deparment_data"
                    disable-pagination
                    hide-default-footer
      >
      </v-data-table>

      <v-toolbar dense dark color="primary" class="mt-10"
                 v-if="(!is_executive||is_executive_head)||(is_csr||is_gad)">
        <v-toolbar-title><h4 class="font-weight-light">Top Employee</h4>
        </v-toolbar-title>
      </v-toolbar>
      <v-data-table dense
                    class="mt-3"
                    :headers="top_employee_headers"
                    :items="top_employee_data"
                    disable-pagination
                    hide-default-footer
      >
      </v-data-table>
    </v-card>
    <snack-bar-dialog
      :snackbar_flag="this.snackbar"
      :color="this.snackbar_color"
      :snackbar_text="this.snackbar_text"
    />
  </div>
</template>

<script>
import {
  mdiAccountOutline, mdiAccountCashOutline
  , mdiInformationOutline
  , mdiBadgeAccountAlertOutline
  , mdiPrinter
  , mdiEyeCircle
} from "@mdi/js";
import moment from "moment";
import {mapActions, mapGetters} from "vuex";
import snackBarDialog from '@/components/dialogs/notifications_dialog/Snackbar'

const initialState = () => {
  return {
    alert: false,
    alert_message: '',

    new_cfo_points: '0',
    is_view_points: false,
    is_change_salary: false,
    is_same_branch: false,
    is_generated: false,
    is_bod_change_points: false,
    saving_data: false,
    is_printing: false,
    saving: false,
    is_head: false,
    is_hr: false,
    is_executive_head: false,
    is_executive: false,
    is_bod: false,
    is_csr: false,
    is_gad: false,
    category_id: '',
    new_incentives: '0',
    employee_position_id: 0,
    month_of_id: '',
    comment: '',
    category_items: [],
    month_of_items: [],
    category_items2: [],
    selected_branch_id: '',
    employee_branch_items: [],
    comments_items: [],
    personal_info: [],
    top_per_deparment_data: [],
    top_head_data: [],
    top_employee_data: [],
    bank_info: [],
    employment_info: [],
    type_of_employee: [],
    employee_position_items: [],
    points_items: [],
    bank_items: [],
    bank_items2: [],
    bank_items3: [],
    all_items: [],
    sorted_by: 'Name',
    bank: '',
    status: 'All',
    duration: 'All',
    maximum_amount: '',
    eval_employee_id: '',
    eval_employee_is_head: '',
    all_answer: '0',
    communications: [
      {model: '0', label: 'Actively listens to supervisors or co-workers.'},
      {model: '0', label: 'Consistently delivers accurate information both written and oral.'},
      {model: '0', label: 'Comprehends written and oral information.'},
      {model: '0', label: 'Reliable provides feedback as required both internally and externally.'},
    ],
    attendances: [
      {model: '0', label: 'Punctual on a regular basis and informs supervisor when late or absent'},
      {model: '0', label: 'Comes to work place regularly and has excellent attendance record'},
      {model: '0', label: 'Employee consistently act with honesty and integrity'},
      {model: '0', label: 'Employee treat colleagues and stakeholders with fairness and respect'},
    ],
    productivities: [
      {model: '0', label: 'Consistently produces quality results.'},
      {model: '0', label: 'Meets deadlines and manages time well.'},
      {model: '0', label: 'Can do multi-tasking.'},
      {model: '0', label: 'Can work under pressure and delivers the required task.'},
      {model: '0', label: 'Effective and efficient in the management.'},
      {
        model: '0',
        label: 'Informs supervisor of any challenge or hindrance met related to given task or arrangement.'
      },
    ],
    initiatives: [
      {model: '0', label: 'Completes assignments with minimum supervision.'},
      {model: '0', label: 'Completes task independently and consistently.'},
      {model: '0', label: 'Seeks support as the need arises.'},
      {model: '0', label: 'Recognize and takes immediate action to effectively address problems.'},
      {model: '0', label: 'Engages and continuous learning.'},
      {model: '0', label: 'Contributes new ideas and shares skills to improve the branch.'},
    ],
    behaviors: [
      {model: '0', label: 'Willing to answer call anytime.'},
      {model: '0', label: 'Works through conflict for positive solutions/results.'},
      {model: '0', label: 'Keeps appointments, call-return commitments, etc.'},
      {
        model: '0',
        label: 'Demonstrates courtesy and a professional attitude in handling customer/agent/supervisors complaints.'
      },
      {
        model: '0',
        label: 'Adapts well to new situations, unusual demands, emergencies, or critical incidents.'
      },
    ],
    csr_ques: [
      {
        model: '0',
        label: 'Actively participates in company-led CSR initiatives (e.g.,outreach programs,environmental projects,community service).'
      },
      {model: '0', label: 'Engages in volunteer services for community development.'},
      {model: '0', label: 'Donates or contributes to CSR programs.'},
    ],
    gad_ques: [
      {
        model: '0',
        label: 'Participates in Gender and Development (GAD) activites promoting inclusivity and equality.'
      },
      {model: '0', label: 'Supports initiatives that empower women and marginalized groups.'},
      {model: '0', label: 'Helps in promoting inclusivity and gender equality in the workplace.'},
    ],
    answer_row: [
      {label: '0', value: '0'},
      {label: '1', value: '1'},
      {label: '2', value: '2'},
      {label: '3', value: '3'},
      {label: '4', value: '4'},
      {label: '5', value: '5'},
    ],
    points_header: [
      {text: 'Particulars', value: 'particulars', sortable: true},
      {text: 'Value', value: 'value', sortable: true},
    ],
    headers: [
      {text: 'No.', value: 'date_of_deposit', sortable: false},
      {text: 'Evaluate', value: 'last_name', sortable: false},
      {text: 'Status', value: 'last_name', sortable: false},
      {text: 'Name', value: 'last_name', sortable: false},
      {text: 'Branch/Department', value: 'last_name', sortable: false},
      {text: 'Designation', value: 'last_name', sortable: false},
      {text: 'Duration', value: 'last_name', sortable: false},
      {text: 'Total Points (100%)', value: 'total_percentage', sortable: true},
      {text: 'Incentives', value: 'incentives', sortable: true},
    ],
    top_head_headers: [
      {text: 'Name', value: 'name', sortable: true},
      {text: 'Department', value: 'department', sortable: true},
      {text: 'Total Points (100%)', value: 'total_percentage', sortable: true},
      {text: 'Incentives', value: 'incentives', sortable: true},
    ],
    top_per_deparment_headers: [
      {text: 'Name', value: 'name', sortable: true},
      {text: 'Department', value: 'department', sortable: true},
      {text: 'Total Points (100%)', value: 'total_percentage', sortable: true},
      {text: 'Incentives', value: 'incentives', sortable: true},
    ],
    top_employee_headers: [
      {text: 'Name', value: 'name', sortable: true},
      {text: 'Department', value: 'department', sortable: true},
      {text: 'Total Points (100%)', value: 'total_percentage', sortable: true},
      {text: 'Incentives', value: 'incentives', sortable: true},
    ],
  }
}
export default {
  components: {
    snackBarDialog,
  },
  setup() {
    return {
      icons: {
        mdiAccountOutline,
        mdiAccountCashOutline,
        mdiInformationOutline,
        mdiBadgeAccountAlertOutline,
        mdiEyeCircle,
        mdiPrinter,
      },
      is_deleting: false,
    }
  },
  data() {
    return initialState()
  },
  mounted() {
    this.is_bod = this.employee_id === 2 || this.employee_id === 1 || this.employee_id === 3
    // this.is_bod = this.employee_id === 1 || this.employee_id === 3
    if (!this.is_can_evaluate) {
      this.$router.push({path: '/error-404'})
    }
    this.initialize_data()
  },
  computed: {
    ...mapGetters('form_rules', ['rules']),
    ...mapGetters('authentication', ['position', 'is_can_evaluate']),
    ...mapGetters('system_data', ['snackbar', 'snackbar_color', 'snackbar_text', 'company_logo', 'damayan', 'chapel', 'factory', 'coop', 'printing']),
    ...mapGetters('authentication', ['position', 'id_no', 'employee_category_id', 'employee_id', 'employee_branch_id']),
    ...mapGetters('authentication', ['address', 'contact', 'name', 'department', 'position']),
  },
  methods: {
    ...mapActions('system_data', ['change_snackbar']),
    ...mapActions('employee_evaluation', ['list_of_employee_to_op_ceo_report',]),
    ...mapActions('employee', ['initialize_list_of_employee_for_evaulation', 'is_head_checker_employee', 'is_csr_gad_checker_employee', 'is_hr_checker_employee', 'is_executive_head_checker_employee', 'is_executive_checker_employee']),
    ...mapActions('employee_evaluation_status', ['create_employee_is_done_evaluate']),
    ...mapActions('employee_evaluation_data', ['create_employee_evaluation_data']),
    is_same_branch_checker(value) {
      return (this.employee_branch_id === value)
    },
    is_head_checker(value) {
      this.is_head_checker_employee({
        employee_id: value
      })
        .then(response => {
          this.is_head = response.data;
        })
      this.is_csr_gad_checker_employee({
        employee_id: value
      })
        .then(response => {
          this.is_csr = response.data[0].is_csr;
          this.is_gad = response.data[0].is_gad;
        })
      this.is_hr_checker_employee({
        employee_id: value
      })
        .then(response => {
          this.is_hr = response.data;
        })
      this.is_executive_head_checker_employee({
        employee_id: value
      })
        .then(response => {
          this.is_executive_head = response.data;
        })
      this.is_executive_checker_employee({
        employee_id: value
      })
        .then(response => {
          this.is_executive = response.data;
        })
    },
    change_all_answer() {
      this.communications[0].model = this.all_answer
      this.communications[1].model = this.all_answer
      this.communications[2].model = this.all_answer
      this.communications[3].model = this.all_answer
      this.attendances[0].model = this.all_answer
      this.attendances[1].model = this.all_answer
      this.attendances[2].model = this.all_answer
      this.attendances[3].model = this.all_answer
      this.productivities[0].model = this.all_answer
      this.productivities[1].model = this.all_answer
      this.productivities[2].model = this.all_answer
      this.productivities[3].model = this.all_answer
      this.productivities[4].model = this.all_answer
      this.productivities[5].model = this.all_answer
      this.initiatives[0].model = this.all_answer
      this.initiatives[1].model = this.all_answer
      this.initiatives[2].model = this.all_answer
      this.initiatives[3].model = this.all_answer
      this.initiatives[4].model = this.all_answer
      this.initiatives[5].model = this.all_answer
      this.behaviors[0].model = this.all_answer
      this.behaviors[1].model = this.all_answer
      this.behaviors[2].model = this.all_answer
      this.behaviors[3].model = this.all_answer
      this.behaviors[4].model = this.all_answer
      this.csr_ques[0].model = this.all_answer
      this.csr_ques[1].model = this.all_answer
      this.csr_ques[2].model = this.all_answer
      this.gad_ques[0].model = this.all_answer
      this.gad_ques[1].model = this.all_answer
      this.gad_ques[2].model = this.all_answer
    },
    async initialize_data() {
      await this.is_head_checker(this.employee_id)
      await this.initialize_list_of_employee_for_evaulation()
        .then(response => {
          this.category_items2 = response.data[0].category
          this.month_of_items = response.data[0].months
        })
        .catch(error => {
          console.log(error)
        })
      if (this.employee_category_id === 1) {
        this.category_items.push(this.category_items2[
          this.category_items2
            .map(function (x) {
              return x.id
            })
            .indexOf(2)
          ])
      } else {
        this.category_items.push(this.category_items2[
          this.category_items2
            .map(function (x) {
              return x.id
            })
            .indexOf(this.employee_category_id)
          ])
      }
    },
    duration_counter(value) {
      var a = moment(this.month_of_items[this.month_of_items.map(function (x) {
        return x.id;
      }).indexOf(this.month_of_id)].month_of, 'MMMM YYYY');
      var b = moment(value, 'YYYY-MM-DD');

      var years = a.diff(b, 'year');
      b.add(years, 'years');

      var months = a.diff(b, 'months');
      b.add(months, 'months');

      var days = a.diff(b, 'days');
      return years + ' years ' + months + ' months ' + days + ' days'
    },
    date_format(value) {
      return moment(value)
    },
    formatPrice(value) {
      let val = (value / 1).toFixed(2).replace(',', '.')
      return val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')
    },
    change_stat_cash_advance(value, is_bod) {
      this.eval_employee_id = value.id
      this.eval_employee_is_head = value.is_head
      if (is_bod) {
        // this.new_cfo_points = value.evaluation.length > 0 ? value.evaluation[0].total + '' : '0';
        // this.is_bod_change_points = true
        this.is_change_salary = true
      } else {
        this.is_same_branch = this.is_same_branch_checker(value.branch_id)
        this.is_change_salary = true
      }
    },
    async view_stat_cash_advance(value) {
      this.points_items = []
      var q1 = 0;
      var q2 = 0;
      var q3 = 0;
      var q4 = 0;
      var q5 = 0;
      var dat = [];
      if (value.over_all_evaluation.length > 0) {
        await value.over_all_evaluation.forEach(function (item) {
          q1 += item.q1;
          q2 += item.q2;
          q3 += item.q3;
          q4 += item.q4;
          q5 += item.q5;

          if (item.comment != null) {
            dat.push({
              comments: item.comment,
            })
          }
        })
      }
      this.comments_items = dat

      this.points_items.push({
        particulars: 'Initiative', value: q1,
      })
      this.points_items.push({
        particulars: 'Punctuality', value: q2,
      })
      this.points_items.push({
        particulars: 'Collaborative', value: q3,
      })
      this.points_items.push({
        particulars: 'Professionalism', value: q4,
      })
      this.points_items.push({
        particulars: 'Interpersonal Communication', value: q5,
      })

      this.is_view_points = true
    },
    update_cash_advance_previlige() {
      this.saving = true
      var proceed = true;
      if (this.is_bod) {
        if (this.new_cfo_points > 25) {
          this.alert = true
          this.alert_message = 'Points not greater then 25'
          this.saving_data = false
          this.saving = false
          this.is_bod_change_points = false
          proceed = false
        }
      }
      if (proceed) {
        this.alert = false
        this.alert_message = ''
        this.saving_data = false
        this.saving = false
        this.evaluate_employee({
          month_of_id: this.month_of_id,
          created_by: this.employee_id,
          employee_id: this.eval_employee_id,
          comment: this.comment.toUpperCase(),
          is_bod: this.is_bod ? 1 : 0,
          is_head: this.is_bod ? 0 : this.is_head,
          is_executive: this.is_bod ? 0 : this.is_executive,
          is_executive_head: this.is_bod ? 0 : this.is_executive_head,
          is_subordinate: this.is_bod ? 0 : (this.is_head ? 0 : 1),
          is_csr: this.is_csr ? 1 : 0,
          is_gad: this.is_gad ? 1 : 0,
          is_hr: this.is_hr ? 1 : 0,

          q1: this.communications[0].model,
          q2: this.communications[1].model,
          q3: this.communications[2].model,
          q4: this.communications[3].model,

          q5: this.attendances[0].model,
          q6: this.attendances[1].model,
          q7: this.attendances[2].model,
          q8: this.attendances[3].model,

          q9: this.productivities[0].model,
          q10: this.productivities[1].model,
          q11: this.productivities[2].model,
          q12: this.productivities[3].model,
          q13: this.productivities[4].model,
          q14: this.productivities[5].model,

          q15: this.initiatives[0].model,
          q16: this.initiatives[1].model,
          q17: this.initiatives[2].model,
          q18: this.initiatives[3].model,
          q19: this.initiatives[4].model,
          q20: this.initiatives[5].model,

          q21: this.behaviors[0].model,
          q22: this.behaviors[1].model,
          q23: this.behaviors[2].model,
          q24: this.behaviors[3].model,
          q25: this.behaviors[4].model,

          q26: this.csr_ques[0].model,
          q27: this.csr_ques[1].model,
          q28: this.csr_ques[2].model,
          q29: this.gad_ques[0].model,
          q30: this.gad_ques[1].model,
          q31: this.gad_ques[2].model,
        }).then(response => {
          this.alert = true
          this.alert_message = response.data
          this.saving_data = false
          this.saving = false
          this.selected_data()
        })
          .catch(error => {
            console.log(error)
          })
      }
    },
    selected_category() {
      if (this.category_items.length > 0) {
        var index = this.category_items
          .map(function (x) {
            return x.id
          })
          .indexOf(this.category_id)
        if (index >= 0) {
          // this.employee_position_items = this.category_items[index].employee_position
          this.employee_position_items.splice(0, 0, {
            id: 0,
            position: 'All'
          })
          this.employee_branch_items = this.category_items[index].branch
          this.employee_branch_items.splice(0, 0, {
            id: 0,
            branch_code: 'All'
          })
          this.employee_branch_items.push({id: 53, branch_code: 'DIGOS COOP'})
          this.employee_branch_items.push({id: 275, branch_code: 'PADADA COOP'})
          this.employee_branch_items.push({id: 161, branch_code: 'DIGOS GLB'})
          this.employee_branch_items.push({id: 307, branch_code: 'GL BOARDING HOUSE'})
          this.employee_branch_items.push({id: 312, branch_code: 'GL FITNESS BLDG'})
          this.employee_branch_items.push({id: 324, branch_code: 'GL EMERALD BUILDING'})
          this.employee_branch_items.push({id: 348, branch_code: 'GL RUBY APARTMENT'})
          this.employee_branch_items.push({id: 363, branch_code: 'GL DIAMOND GETAWAY'})
          this.employee_branch_items.push({id: 366, branch_code: 'DIGOS 2'})
          this.employee_branch_items.push({id: 367, branch_code: 'GL TOPAZ APARTMENT'})
          this.selected_data()
        }
      }
    },
    selected_bank_data() {
      var index = this.bank_items
        .map(function (x) {
          return x.bank_type
        })
        .indexOf(this.bank)
      if (index >= 0) {
        this.top_per_deparment_data = this.bank_items[index].detail
        this.top_head_data = this.bank_items3[index].detail
        this.top_employee_data = this.bank_items2[index].detail
      }
    },
    selected_data() {
      const data = new FormData()
      this.top_per_deparment_data = []
      this.top_head_data = []
      this.top_employee_data = []
      data.append('month_of_id', this.month_of_id);
      this.list_of_employee_to_op_ceo_report(data)
        .then(response => {
          this.top_head_data = response.data[0].data
          this.top_per_deparment_data = response.data[0].data1
          this.top_employee_data = response.data[0].data2
        })
        .catch(error => {
          console.log(error)
        })
      this.saving = false
    },
    approved_data() {
      this.saving_data = true
      this.alert = false

      if (this.personal_info.length > 0) {
        var can_final = true
        // this.personal_info.forEach(function (item) {
        //   if (Object.keys(item.has_done_evaluate).length === 0) {
        //     can_final = false;
        //   }
        // })
        if (can_final) {
          const data = new FormData()
          data.append('month_of_id', this.month_of_id);
          data.append('category_id', this.category_id);
          data.append('evaluation_data_executive', JSON.stringify(this.top_head_data));
          data.append('evaluation_data', JSON.stringify(this.top_per_deparment_data));
          data.append('evaluation_data_department', JSON.stringify(this.top_employee_data));
          this.create_employee_evaluation_data(data)
            .then(() => {
              this.saving_data = false
              this.selected_data()
            })
            .catch(error => {
              console.log(error)
            })
        } else {
          this.alert = true
          this.alert_message = 'Not all employee evaluated'
          this.saving_data = false
        }
      } else {
        this.alert = true
        this.alert_message = 'No Data'
        this.saving_data = false
      }
    },
    print_data() {
      this.is_printing = true
      this.alert = false

      var imgData = this.company_logo
      var payments_array = []
      var payments_array2 = []
      var payments_array3 = []
      var widths = []
      var info_array = []
      var info_array3 = []
      var info_array2 = []
      widths = [20, 150, 120, 90, 80, 80, 30, 50]
      payments_array3.push([
        {text: 'No.', alignment: 'left', style: 'main_info',},
        {text: 'Name', alignment: 'left', style: 'main_info'},
        {text: 'Branch/Department', alignment: 'left', style: 'main_info'},
        {text: '%', alignment: 'left', style: 'main_info'},
        {text: 'Incentives', alignment: 'left', style: 'main_info'},
      ])
      payments_array.push([
        {text: 'No.', alignment: 'left', style: 'main_info',},
        {text: 'Name', alignment: 'left', style: 'main_info'},
        {text: 'Branch/Department', alignment: 'left', style: 'main_info'},
        {text: '%', alignment: 'left', style: 'main_info'},
        {text: 'Incentives', alignment: 'left', style: 'main_info'},
      ])
      payments_array2.push([
        {text: 'No.', alignment: 'left', style: 'main_info',},
        {text: 'Name', alignment: 'left', style: 'main_info'},
        {text: 'Branch/Department', alignment: 'left', style: 'main_info'},
        {text: '%', alignment: 'left', style: 'main_info'},
        {text: 'Incentives', alignment: 'left', style: 'main_info'},
      ])
      var value = this.top_per_deparment_data;
      var value2 = this.top_employee_data;
      var value3 = this.top_head_data;
      var total_am = 0
      value3.forEach(function (item) {
        total_am += parseFloat(item.incentives)
        payments_array3.push([
          {
            text: (value3
              .map(function (x) {
                return x.id
              })
              .indexOf(item.id) + 1),
            alignment: 'left',
            style: 'tableExample2'
          },
          {
            text: item.name,
            alignment: 'left',
            style: 'tableExample2'
          },
          {
            text: item.department,
            alignment: 'left',
            style: 'tableExample2'
          },
          {
            text: item.total_percentage + '%',
            alignment: 'left',
            style: 'tableExample2'
          },
          {
            text: (item.incentives / 1)
              .toFixed(2)
              .replace(',', '.')
              .toString()
              .replace(/\B(?=(\d{3})+(?!\d))/g, ','),
            alignment: 'left',
            style: 'tableExample2'
          },
        ])
      })
      value.forEach(function (item) {
        total_am += parseFloat(item.incentives)
        payments_array.push([
          {
            text: (value
              .map(function (x) {
                return x.id
              })
              .indexOf(item.id) + 1),
            alignment: 'left',
            style: 'tableExample2'
          },
          {
            text: item.name,
            alignment: 'left',
            style: 'tableExample2'
          },
          {
            text: item.department,
            alignment: 'left',
            style: 'tableExample2'
          },
          {
            text: item.total_percentage + '%',
            alignment: 'left',
            style: 'tableExample2'
          },
          {
            text: (item.incentives / 1)
              .toFixed(2)
              .replace(',', '.')
              .toString()
              .replace(/\B(?=(\d{3})+(?!\d))/g, ','),
            alignment: 'left',
            style: 'tableExample2'
          },
        ])
      })
      value2.forEach(function (item) {
        total_am += parseFloat(item.incentives)
        payments_array2.push([
          {
            text: (value2
              .map(function (x) {
                return x.id
              })
              .indexOf(item.id) + 1),
            alignment: 'left',
            style: 'tableExample2'
          },
          {
            text: item.name,
            alignment: 'left',
            style: 'tableExample2'
          },
          {
            text: item.department,
            alignment: 'left',
            style: 'tableExample2'
          },
          {
            text: item.total_percentage + '%',
            alignment: 'left',
            style: 'tableExample2'
          },
          {
            text: (item.incentives / 1)
              .toFixed(2)
              .replace(',', '.')
              .toString()
              .replace(/\B(?=(\d{3})+(?!\d))/g, ','),
            alignment: 'left',
            style: 'tableExample2'
          },
        ])
      })

      info_array3 = [
        {
          columns: [
            {
              style: 'main_info',
              text: [
                {
                  text: 'Month Of: ' + this.month_of_items[this.month_of_items.map(function (x) {
                    return x.id;
                  }).indexOf(this.month_of_id)].month_of,
                  style: 'main_data',
                },
              ],
            },

          ],
        }, {
          columns: [
            {
              style: 'main_info',
              text: [
                {
                  text: 'Total Of: ' + (total_am / 1)
                    .toFixed(2)
                    .replace(',', '.')
                    .toString()
                    .replace(/\B(?=(\d{3})+(?!\d))/g, ','),
                  style: 'main_data',
                },
              ],
            },

          ],
        },
        {
          columns: [
            {
              style: 'main_info',
              text: [
                'TOP 3 Managers',
              ],
            },
          ],
        },
      ]
      info_array2 = [
        {
          columns: [
            {
              style: 'main_info',
              text: [
                'Top 1 Employee',
              ],
            },
          ],
        },
      ]
      info_array = [
        {
          columns: [
            {
              style: 'main_info',
              text: [
                'Top 1 Employee per Department',
              ],
            },
          ],
        },
      ]

      //call pdfmake
      var pdfMake = require('pdfmake/build/pdfmake.js')
      if (pdfMake.vfs == undefined) {
        var pdfFonts = require('pdfmake/build/vfs_fonts.js')
        pdfMake.vfs = pdfFonts.pdfMake.vfs
      }
      var docDefinition = {
        pageSize: 'LETTER',
        pageOrientation: 'portrait',
        content: [
          {
            columns: [
              {image: imgData, width: 54, height: 54, style: 'logo'},
              {
                stack: [
                  'GOODLIFE GROUP OF COMPANIES',
                  {text: this.address, style: 'subheader'},
                  {
                    text: this.contact,
                    style: 'subheader',
                  },
                  {
                    text: 'Printed as of: ' + moment().format('MMMM D, YYYY'),
                    style: 'printed_label',
                  },
                ],
                style: 'header',
              },
            ],
          },
          '_______________________________________________________________________________________________',
          {
            stack: [
              {
                columns: [
                  {
                    text: 'OPCEO MONTHLY EVALUATION EMPLOYEES',
                    style: {
                      fontSize: 16,
                      alignment: 'center',
                      bold: true,
                      color: 'blue',
                    },
                  },
                ],
              },
            ],
          },
          {
            columns: [{text: ' '}],
          },
          {
            columns: [{text: ' '}],
          },
          {
            stack: info_array3,
          },
          {
            columns: [{text: ' '}],
          },
          {
            table: {
              widths: widths,
              body: payments_array3,
              style: {fontSize: 1},
            },
          },
          '_______________________________________________________________________________________________',
          {
            stack: info_array,
          },
          {
            columns: [{text: ' '}],
          },
          {
            table: {
              widths: widths,
              body: payments_array,
              style: {fontSize: 1},
            },
          },
          '_______________________________________________________________________________________________',
          {
            stack: info_array2,
          },
          {
            table: {
              widths: widths,
              body: payments_array2,
              style: {fontSize: 1},
            },
          },
          {
            stack: [
              {
                columns: [{text: ' '}],
              },
              {
                columns: [{text: ' '}],
              },
              {
                columns: [
                  {
                    text: 'PROCESSED BY',
                    style: 'main_data_2',
                  },
                  {
                    text: 'DEPARTMENT RECEIVER',
                    style: 'main_data_2',
                  },
                  {
                    text: 'RECEIVED BY',
                    style: 'main_data_2',
                  },
                ],
              },
              {
                columns: [
                  {
                    text: this.name,
                    style: 'main_data_2',
                  },
                  {
                    text: ' ',
                  },
                  {
                    text: '',
                  },
                ],
              },
              {
                columns: [
                  {
                    text: '_____________________',
                  },
                  {
                    text: '_____________________',
                  },
                  {
                    text: '_____________________',
                  },
                ],
              },
              {
                columns: [
                  {
                    text: this.position,
                    style: 'main_data_2',
                  },
                  {
                    text: 'Signature Over Printed Name',
                    style: 'main_data_2',
                  },
                  {
                    text: 'Signature Over Printed Name',
                    style: 'main_data_2',
                  },
                ],
              },
              {
                columns: [
                  {
                    text: 'VERIFIED BY',
                    style: 'main_data_2',
                  },
                  {
                    text: '',
                  },
                  {
                    text: '',
                  },
                ],
              },
              {
                columns: [
                  {
                    text: '_________________________________________',
                  },
                  {
                    text: ' ',
                  },
                  {
                    text: ' ',
                  },
                ],
              },
              {
                columns: [
                  {
                    text: 'BOARD OF DIRECTOR',
                    style: 'main_data_2',
                  },
                  {
                    text: '',
                  },
                  {
                    text: '',
                  },
                ],
              },
            ],
          },
          {
            columns: [
              {image: this.damayan, width: 54, height: 40, style: 'logo'},
              {image: this.chapel, width: 54, height: 40, style: 'logo'},
              {image: this.factory, width: 54, height: 40, style: 'logo'},
              {image: this.coop, width: 54, height: 40, style: 'logo'},
              {image: this.printing, width: 54, height: 40, style: 'logo'},
            ],
          },
        ],
        footer: {
          // columns: [
          //     {
          //         text: 'Generated with Goodlife Savings & Credit Cooperative System',
          //         alignment: 'center',
          //         style: 'tableExample'
          //     }
          // ]
        },
        styles: {
          tableExample: {
            fontSize: 9,
          },
          tableExample2: {
            fontSize: 7,
          },
          header: {
            fontSize: 21,
            bold: true,
            alignment: 'left',
            margin: [6, 6, 0, 5], //[left, top, right, bottom]
          },
          subheader: {
            fontSize: 11,
          },
          logo: {
            alignment: 'center',
            margin: [0, 0, 0, 0], //[left, top, right, bottom]
          },
          printed_label: {
            alignment: 'right',
            fontSize: 9,
            margin: [0, 0, 0, 0], //[left, top, right, bottom]
          },
          main_data: {
            margin: [0, 2, 0, 2],
            fontSize: 11,
            bold: true,
            alignment: 'left',
          },
          main_data_2: {
            margin: [0, 2, 0, 2],
            fontSize: 8,
            bold: true,
            alignment: 'left',
          },
          main_info: {
            margin: [0, 2, 0, 2],
            fontSize: 10,
            alignment: 'left',
          },
        },
      }
      pdfMake.createPdf(docDefinition).open()
      this.is_printing = false
    }
  },
}
</script>
